import { apiClient } from './api';

export interface ZaloZnsTemplate {
  _id: string;
  name: string;
  template_id: string;
  code: string;
  content: string;
  params: string[];
  state: number;
  created_at: string;
  updated_at: string;
}

export interface CreateZaloZnsTemplateDto {
  name: string;
  template_id: string;
  code: string;
  content: string;
  params?: string[];
  state?: number;
}

export interface UpdateZaloZnsTemplateDto extends Partial<CreateZaloZnsTemplateDto> { }

export interface ZaloZnsTemplateFilters {
  page?: number;
  limit?: number;
  q?: string;
  state?: number;
  sort?: string;
  order?: string;
}

export interface ZaloZnsTemplatesResponse {
  data: ZaloZnsTemplate[];
  meta: {
    page: number;
    limit: number;
    total: number;
    totalPages: number;
  };
}

export const zaloZnsTemplateService = {
  getAll: async (filters: ZaloZnsTemplateFilters = {}): Promise<ZaloZnsTemplatesResponse> => {
    const response = await apiClient.get('/zalo-zns-templates', { params: filters });
    return response.data.data;
  },

  getById: async (id: string): Promise<ZaloZnsTemplate> => {
    const response = await apiClient.get(`/zalo-zns-templates/${id}`);
    return response.data.data;
  },

  create: async (data: CreateZaloZnsTemplateDto): Promise<ZaloZnsTemplate> => {
    const response = await apiClient.post('/zalo-zns-templates', data);
    return response.data.data;
  },

  update: async (id: string, data: UpdateZaloZnsTemplateDto): Promise<ZaloZnsTemplate> => {
    const response = await apiClient.put(`/zalo-zns-templates/${id}`, data);
    return response.data.data;
  },

  deleteMany: async (ids: string[]): Promise<{ deleted: number }> => {
    const response = await apiClient.delete('/zalo-zns-templates', { data: { ids } });
    return response.data.data;
  },

  clone: async (id: string): Promise<ZaloZnsTemplate> => {
    const response = await apiClient.post(`/zalo-zns-templates/clone/${id}`);
    return response.data.data;
  },
};

export default zaloZnsTemplateService;
